import { render, staticRenderFns } from "./simType.vue?vue&type=template&id=52e5fc70&scoped=true"
import script from "./simType.vue?vue&type=script&lang=js"
export * from "./simType.vue?vue&type=script&lang=js"
import style0 from "./simType.vue?vue&type=style&index=0&id=52e5fc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5fc70",
  null
  
)

export default component.exports